import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import CreateIcon from "@material-ui/icons/Create";
import { HandleErrorAndLoading } from "@common/handleErrorAndLoading/HandleErrorAndLoading";
import { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";
import { ROUTES } from "@constants";
import { useHistory } from "react-router-dom";
import { useGetCustomerDetails } from "./hook/useGetCustomerDetails";
import { ICustomerDetails } from "@interface/customerDetails/ICustomerDetails";
import { fixUrlLanguage } from "@utils/changeLanguage";
import { keycloakUtils } from "src/itsf/keycloak/keycloakUtils";

export const SummaryCustomerDetails = () => {
    const [customerDetails, setCustomerDetails] = useState<ICustomerDetails | undefined>();
    const Authenticated = keycloakUtils.isAuthenticated();
    const { t } = useTranslation(["address", "customerDetails"]);
    const { replace, push } = useHistory();
    const callbackGetCustomerDetails = (customerDetailsResult?: ICustomerDetails) => {
        if (customerDetailsResult?.owner) {
            setCustomerDetails(customerDetailsResult);
        } else {
            replace(fixUrlLanguage(ROUTES.DETAILS_PAGE_URL_EN));
        }
    };

    const { getCustomerDetailsState, getCustomerDetails } = useGetCustomerDetails(push, callbackGetCustomerDetails);

    const handleEditCustomerDetails = () => {
        push(fixUrlLanguage(ROUTES.DETAILS_PAGE_URL_EN));
    };

    return (
        <HandleErrorAndLoading
            error={getCustomerDetailsState.error}
            isLoading={getCustomerDetailsState.isLoading}
            retryFetch={getCustomerDetails}
        >
            {customerDetails && (
                <Fragment>
                    <Grid container>
                        <Grid item xs={10}>
                            <Typography color="inherit" gutterBottom variant="h2">
                                {t("customerDetails:customerDetails")}
                            </Typography>
                        </Grid>
                        {!Authenticated && (<Grid className="summary-customer__edit" item xs={2}>
                            <IconButton aria-label="Create" color="inherit" onClick={handleEditCustomerDetails}>
                                <CreateIcon />
                            </IconButton>
                        </Grid>)}
                    </Grid>
                    <Grid item xs={12}>
                        <Typography color="inherit">
                            {customerDetails.owner.person.firstName} {customerDetails.owner.person.lastName}
                        </Typography>
                        <Typography color="inherit" variant="body1">
                            {customerDetails.billingAddress.streetNumber} {customerDetails.billingAddress.street} STREET
                        </Typography>
                        <Typography color="inherit" variant="body1">
                            {customerDetails.billingAddress.area} {customerDetails.billingAddress.city}{" "}
                            {customerDetails.billingAddress.postalCode}
                        </Typography>
                        <Typography color="inherit">{customerDetails.billingAddress.streetQualifier}</Typography>
                        {customerDetails.billingAddress.enablePostalBox && (
                            <Typography color="inherit">
                                {t("customerDetails:postalBox") + ": "}
                                {customerDetails.billingAddress.postalBox}
                            </Typography>
                        )}
                        <Typography color="inherit">
                            {t(customerDetails.billingAddress.buildingType as any)}{" "}
                            {customerDetails.billingAddress.buildingName} {customerDetails.billingAddress.flatNumber}
                        </Typography>
                    </Grid>
                </Fragment>
            )}
        </HandleErrorAndLoading>
    );
};
